import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d47a613&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0d47a613&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47a613",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d47a613')) {
      api.createRecord('0d47a613', component.options)
    } else {
      api.reload('0d47a613', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d47a613&scoped=true", function () {
      api.rerender('0d47a613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navigationConfig/index.vue"
export default component.exports